export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    type: 'checkbox',
    width: 50,
    align: 'center',
    fixed: 'left',
    visible: !that.disabled,
  },
  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    align: 'center',
    width: 80,
    visible: !that.disabled,
    slots: { default: 'opt' },
  },
  {
    title: that.$l('table_label_expenseName') || '费用项目',
    field: 'expenseName',
    align: 'center',
    width: 200,
    editRender: { enabled: true },
    slots: { edit: 'expense' },
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_financeExpense') || '财务费用',
    field: 'v_expenseType',
    align: 'center',
    width: 200,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_currencyAmount') || '费用金额',
    field: 'currencyAmount',
    align: 'center',
    width: 180,
    showHeaderOverflow: true,
    showOverflow: true,
    editRender: {
      name: 'ElInputNumber',
      props: {
        precision: 2,
        min: 0,
        max: 1000000000,
        step: 0.01,
        'controls-position': 'right',
      },
    },
  },
  {
    title: that.$l('table_label_substituteInvoice') || '代用发票',
    field: 'substituteInvoice',
    align: 'center',
    width: 150,
    editRender: { enabled: true },
    slots: { default: 'substituteInvoiceShow', edit: 'substituteInvoice' },
    visible: that.showSubstituteInvoice
  },
  {
    title: that.$l('table_label_originalExpenseType') || '原始费用项目',
    field: 'v_originalExpenseType',
    align: 'center',
    width: 200,
    editRender: { enable: true },
    slots: { edit: 'originalExpenseType' },
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_orgDepFullName') || '分摊部门',
    field: 'orgDepFullName',
    headerAlign: 'center',
    align: 'left',
    minWidth: 300,
    editRender: { enable: true },
    slots: { edit: 'depCode' },
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_custCode') || '费用客户',
    field: 'custName',
    headerAlign: 'center',
    align: 'left',
    minWidth: 250,
    editRender: { enable: true },
    slots: { edit: 'customer' },
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_brand') || '品牌',
    field: 'brandCode',
    headerAlign: 'center',
    align: 'left',
    minWidth: 200,
    editRender: {
      name: 'dict-select',
      props: {
        url: '/master/common/dict/brandSelect',
        filterable: true,
        clearable: true,
        size: 'mini',
        placeholder: that.$l('table_label_please_select_brand') || '请选择品牌',
      },
    },
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_expenseRemark') || '费用说明',
    field: 'expenseRemark',
    align: 'center',
    width: 180,
    showHeaderOverflow: true,
    showOverflow: true,
    editRender: {
      name: 'ElInput',
      props: {
        maxlength: 200,
      },
    },
  },
]
